import '../../../../vendor/jquery.query';
import Overlay from '../../../common/overlay.js';
import RoutingManager from '../../../common/routing-manager.js';
import Translator from 'bazinga-translator';

var locale = $('html').attr('lang');  // site locale
var translations = require('./translations/'+locale+'.json');
Translator.fromJSON(translations);

var restaurants_sort = RoutingManager.getUrlParameter('sort');
var restaurants_sort_direction = RoutingManager.getUrlParameter('dir');

/**
 * --------------------------------------------------------------------
 * Listeners
 * --------------------------------------------------------------------
 */

var options_to_select = $(document).find('[data-sort="' + restaurants_sort + '"][data-sort-dir="' + restaurants_sort_direction + '"]');

if (options_to_select.length > 0) {
    $('.restaurant-sort').val($(options_to_select[0]).attr('value'));
}

$('.restaurant-sort').on('change', function(){

    window.location = jQuery.query
        .set("sort", $('.restaurant-sort option:selected').data('sort'))
        .set("dir", $('.restaurant-sort option:selected').data('sort-dir'))
    ;
    $('#loader').removeClass('hidden');
});

/**
 * ********************************************************************
 * Group checkbox for restaurants search form
 *  - after the website is reloaded, checkboxes need do be opened again
 * ********************************************************************
 */

$('.area-subarea > .group')
    .find('input[type="checkbox"]')
    .each(function () {
        var cbx = $(this);
        if (cbx.prop('checked')) {
            cbx.parents().eq(2).find('input.group-checkbox').prop('checked', true);
            cbx.parents().eq(1).show();
        }
    });

/**
 * ********************************************************************
 * Group checkbox for restaurants search form
 *  - once the checkbox group is selected, all group subcheckboxes
 *  must be selected too
 * ********************************************************************
 */

$('.group-checkbox').change(function () {

    var groupId = $(this).data('group-id');
    var groupDiv = $('#subarea-group-' + groupId);
    var subCheckboxes = groupDiv.find('input[type="checkbox"]');

    groupDiv.toggle();

    if (groupDiv.is(":visible") == true) {
        subCheckboxes.each(function () {
            $(this).prop('checked', true);
        });
    } else {
        subCheckboxes.each(function () {
            $(this).prop('checked', false);
        });
    }

    Overlay.show(Translator.trans("updating_results")); // show "in progress..." bar
    $('.detailed-search-form').submit(); // submit the form
});

/**
 * ********************************************************************
 * Search form checkbox click
 *  - on every change of one of the checkbox inputs, search results
 *  must be updated
 * ********************************************************************
 */

// auto submit on every checkbox click
$('.checkbox, .area-subarea input[type="checkbox"], .reset-button-container > .btn').change(function (event) {
    Overlay.show(Translator.trans("updating_results")); // show "in progress..." bar
    $('.detailed-search-form').submit(); // submit the form
});

$('.restaurants-sort-dropdown').on('change', function(){
    window.location = jQuery.query
        .set("sort", $('#restaurants-sort-dropdown option:selected').data('sort'))
        .set("dir", $('#restaurants-sort-dropdown option:selected').data('sort-dir'))
    ;
    $('#loader').removeClass('hidden');
});

/**
 * ********************************************************************
 * Mobile
 *  -
 * ********************************************************************
 */

$('.rental-item .detailed-search-form .search-form-cell button.show-more-button').click(function(event){
    event.preventDefault();
    $(this).parent().find('.content-fields').slideToggle();
});
